document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form.js-admin-ugc-edit-form');

  if (!form) {
    return;
  }

  const container = document.querySelector('body');

  form.addEventListener('input', (event) => {
    console.log('input');
    container.classList.add('is-ugc-content-changing');
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const submitButton = form.querySelector('input[type="submit"]');
    const formData = new FormData(form);

    const resetSubmitButton = () => {
      submitButton.value = '保存する';
      submitButton.disabled = false;
    };

    fetch(form.action, {
      method: form.method,
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          alert('保存しました。');

          resetSubmitButton();
          container.classList.remove('is-ugc-content-changing');
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (!data) {
          return;
        }

        const errors = data.errors;

        alert(`保存に失敗しました：\n\n${errors.join('\n')}`);

        resetSubmitButton();
      });

    return false;
  });
});
